import React, { useState, useEffect } from 'react';
import {
    Alert,
    Container,
    Header as HeaderRS,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import {
    Header,
    Form,
    Button,
    Segment,
    Icon,
    Dropdown,
    Divider } from 'semantic-ui-react';
import { api } from '../../../services/api';

import Navbarr from '../../../components/Navbar';

export default function ProdCreate({ sidebar: Sidebar}) {
    const [prodStates, setProdStates] = useState({
        route: {},
        formProd: {
            nome: '',
            lojas: [],
            competidores: []
        },
        storesOptions: [],
        comptOptions: [],
        isLoading: false
    });


    const resetProdStates = () => {
        setProdStates( prevState => ({
            ...prevState,
            formProd: {
                nome: '',
                lojas: [],
                competidores: []
            },
            //storeOptions: [],
            //comptOptions: [],
            isLoading: false
        }));
    }

    const handleNomeChange = (e, {value}) => {
        setProdStates( prevState => ({
            ...prevState,
            formProd: {
                ...prevState['formProd'],
                nome: value
            }
        }));
    }

    const handleStoresChange = (e, {value}) => {
        setProdStates((prevState) => ({
            ...prevState,
            formProd: {
                ...prevState['formProd'],
                lojas: value
            }
        }));
    }

    const handleComptChange = (e, {value}) => {
        setProdStates((prevState) => ({
            ...prevState,
            formProd: {
                ...prevState['formProd'],
                competidores: value
            }
        }));
    }

    async function handlePost() {
        try {
            setProdStates( prevState => ({
                ...prevState,
                isLoading: true,
            }));
            const competidores = [];
            const lojas = [];

            prodStates['formProd']['competidores'].forEach(
                cp => competidores.push({'id':cp})
            );

            prodStates['formProd']['lojas'].forEach(
                loja => lojas.push({'id':loja})
            );

            /*const data = */await api.postOwnProduct(prodStates['formProd']['nome'],
                                            competidores, lojas);
            Alert.success("Produto cadastrado com sucesso!");
            resetProdStates();
        } catch (err) {
            Alert.error("Falha ao cadastrar produto. Verifique os campos e tente novamente.");
            console.error('Falha ao cadastrar produto: ', err);
            setProdStates( prevState=> ({
                ...prevState,
                isLoading: false,
            }));
        }
    }

    useEffect(() => {
        async function fetchStores() {
            try {
                const storesOptions = [];
                const stores = await api.getStores();
                stores.forEach(
                    stor => {
                        storesOptions.push({key: stor['id'],
                                            text: stor['nome'],
                                            value: stor['id']});
                    }
                );
                setProdStates(prevState => ({
                    ...prevState,
                    stores: stores,
                    storesOptions: storesOptions,
                }));
            } catch (err) {
                console.error('Falha ao obter lojas: ',err);
            }
        }

        async function fetchCompt() {
            try {
                const comptOptions = [];
                const data = await api.getCompProducts();
                data.forEach(
                    cp => {
                        comptOptions.push({key: cp['id'],
                                            text: cp['nome'],
                                            value: cp['id']});
                    }
                );
                setProdStates(prevState => ({
                    ...prevState,
                    comptOptions: comptOptions,
                }));
            } catch (err) {
                console.error('Falha ao obter competidores: ', err);
            }
        }

        fetchStores();
        fetchCompt();
    },[]);

    return (
        <Container>
            <Side style={{ flex: '0 0 auto', width: 'auto' }}>
                <Sidebar page={"productnew"}></Sidebar>
            </Side>
            <Container>
                <HeaderRS>
                    <Navbarr></Navbarr>
                </HeaderRS>
                <Content style={{ backgroundColor: '#FAFAFA', padding: '5px'}}>
                    <div>
                        <Segment
                            loading={prodStates['isLoading']}
                            style={{ boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' }}
                            >
                            <Header as='h3' floated='left'>
                                Novo Produto
                            </Header>

                            <Divider clearing />
                            Preencha os campos com as informações do produto
                            <Form style={{marginTop: '15px'}}>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            iconPosition='left'
                                            icon='coffee'
                                            fluid label='Nome'
                                            placeholder='Nome'
                                            value={prodStates['formProd']['nome']}
                                            onChange={handleNomeChange}
                                        />
                                    </Form.Group>

                                    {/* Dropdown competidores*/}
                                    <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Competidores</label>
                                        </Form.Group>
                                    <Form.Group inline>
                                        <Dropdown
                                            options={prodStates['comptOptions']}
                                            placeholder='Escolha competidores'
                                            search
                                            selection
                                            fluid
                                            multiple
                                            value={prodStates['formProd']['competidores']}
                                            onChange={handleComptChange}
                                        />
                                    </Form.Group>

                                    {/* Dropdown lojas*/}
                                    <Form.Group inline style={{marginBottom: '4px'}}>
                                        <label>Lojas</label>
                                    </Form.Group>
                                    <Form.Group inline>
                                        <Dropdown
                                            options={prodStates['storesOptions']}
                                            placeholder='Escolha lojas'
                                            search
                                            selection
                                            fluid
                                            multiple
                                            value={prodStates['formProd']['lojas']}
                                            onChange={handleStoresChange}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            primary
                                            size="mini"
                                            floated='right'
                                            onClick={handlePost}
                                            type='submit'>
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='save'/> Salvar
                                                </div>
                                        </Button>
                                    </Form.Group>
                                </Form>
                            </Segment>
                        </div>
                    </Content>
                <Footer></Footer>
            </Container>
        </Container>
    );
}
